import { createIconComponent } from '../../factory/create-icon-component';

export const UnassortItemIcon = createIconComponent(
  'UnassortItemIcon',
  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(4.1, 4.1)">
      <path
        d="M3.66715 2.66634C3.66715 3.40272 3.0702 3.99967 2.33382 3.99967C1.59744 3.99967 1.00049 3.40272 1.00049 2.66634C1.00049 1.92996 1.59744 1.33301 2.33382 1.33301C3.0702 1.33301 3.66715 1.92996 3.66715 2.66634Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <ellipse
        cx="2.33382"
        cy="13.3333"
        rx="1.33333"
        ry="1.33333"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <ellipse
        cx="7.6672"
        cy="2.66634"
        rx="1.33333"
        ry="1.33333"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="2.33382"
        cy="7.99935"
        r="1.33333"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <ellipse
        cx="13.0004"
        cy="2.66634"
        rx="1.33333"
        ry="1.33333"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.43884 14.8336L14.3334 7.16699M6.43884 7.16699L14.3334 14.8336"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>,
);
